//Action Types
export var PRODUCTS_RESET_ACTION_TYPE = "products/reset";
export var PRODUCTS_CLEAN_LOOKUP_ACTION_TYPE = "products/clean_lookup";
export var PRODUCTS_FETCH_START_ACTION_TYPE = "products/fetch_start";
export var PRODUCTS_FETCH_SUCCESS_ACTION_TYPE = "products/fetch_success";
export var PRODUCTS_GET_START_ACTION_TYPE = "products/get_start";
export var PRODUCTS_GET_SUCCESS_ACTION_TYPE = "products/get_success";
export var PRODUCTS_LOOKUP_START_ACTION_TYPE = "products/lookup_start";
export var PRODUCTS_LOOKUP_SUCCESS_ACTION_TYPE = "products/lookup_success";
export var PRODUCTS_SAVE_START_ACTION_TYPE = "products/save_start";
export var PRODUCTS_SAVE_SUCCESS_ACTION_TYPE = "products/save_success";
export var PRODUCTS_CREATE_PRODUCT_BY_CODE_START_ACTION_TYPE = "products/create_product_by_code_start";
export var PRODUCTS_CREATE_PRODUCT_BY_CODE_SUCCESS_ACTION_TYPE = "products/create_product_by_code_success";
export var PRODUCTS_DELETE_START_ACTION_TYPE = "products/delete_start";
export var PRODUCTS_DELETE_SUCCESS_ACTION_TYPE = "products/delete_success";
export var PRODUCTS_ERROR_ACTION_TYPE = "products/error";
